import type { GetAnalysisResultsReturn } from '../../@types/contracts';
import { makeAPIRequestV2 } from '../../utils/api';

export const rerunAiAnalysis = async (
  imageRotations: {
    imageId: string;
    rotation?: number;
    mirrorImage?: boolean;
  }[],
  estimatedVisitId?: number,
): Promise<GetAnalysisResultsReturn[]> => {
  const rerunAnalysisResult = await makeAPIRequestV2(
    '/v2/analyze-image/rerun-analysis',
    {
      data: {
        images: imageRotations,
        estimatedVisitId,
      },
    },
    'POST',
  );
  return rerunAnalysisResult.data;
};
